import React, { useEffect, useState } from 'react'
import { QrCode, Copy, Check } from 'lucide-react'
import api from '../api'
import { Card, PageHeader, Field, Input, Button, Alert, Badge } from '../components/ui'

// Fase 3 "Bayar Online" (2026-07-26) -- server key Midtrans (app_config, lihat server/routes/
// midtransSettings.js). Mode sandbox/production TIDAK dipilih manual di sini -- otomatis terdeteksi
// dari prefix key ('SB-' = sandbox) begitu disimpan, cukup ganti key kalau mau pindah mode.
function SectionTitle({ icon: Icon, children }) {
  return (
    <h2 style={{ fontSize: 14.5, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text)' }}>
      <Icon size={16} color="var(--brand)" />{children}
    </h2>
  )
}

export default function PengaturanMidtrans() {
  const [serverKey, setServerKey] = useState('')
  const [mode, setMode] = useState(null)
  const [webhookUrl, setWebhookUrl] = useState('')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [pesan, setPesan] = useState(null)
  const [copied, setCopied] = useState(false)

  useEffect(() => { load() }, [])

  async function load() {
    setLoading(true)
    try {
      const res = await api.get('/midtrans/pengaturan')
      setServerKey(res.data.serverKey)
      setMode(res.data.mode)
      setWebhookUrl(res.data.webhookUrl)
    } finally { setLoading(false) }
  }

  async function simpan() {
    setPesan(null)
    setSaving(true)
    try {
      await api.post('/midtrans/pengaturan', { serverKey })
      setPesan({ type: 'success', text: 'Server key tersimpan.' })
      load()
    } catch (e) {
      setPesan({ type: 'error', text: e.response?.data?.message || 'Gagal menyimpan server key' })
    } finally { setSaving(false) }
  }

  function salinWebhook() {
    navigator.clipboard.writeText(webhookUrl)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  if (loading) return null

  return (
    <div>
      <PageHeader title="Pengaturan Midtrans" subtitle="Server key & webhook untuk pembayaran online di halaman invoice publik" />

      {pesan && <Alert type={pesan.type}>{pesan.text}</Alert>}

      <Card style={{ padding: 24, marginBottom: 20 }}>
        <SectionTitle icon={QrCode}>Server Key</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>
          Diambil dari dashboard Midtrans (Settings &gt; Access Keys). Mode terdeteksi otomatis dari prefix key -- key diawali <code>SB-</code> berarti Sandbox, selain itu Production. Ganti key ini kapan saja untuk pindah mode.
          {mode && <> Saat ini: <Badge tone={mode === 'sandbox' ? 'warning' : 'success'}>{mode === 'sandbox' ? 'Sandbox' : 'Production'}</Badge></>}
        </p>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16 }}>
          Metode pembayaran yang muncul di halaman Bayar (QRIS, transfer VA, e-wallet, dst) ikut pengaturan <strong>Settings &gt; Payment Methods</strong> di dashboard Midtrans -- aktif/nonaktifkan metode dari sana, bukan dari halaman ini.
        </p>
        <Field label="Server Key" style={{ marginBottom: 14 }}>
          <Input type="password" value={serverKey} onChange={e => setServerKey(e.target.value)} placeholder="Mid-server-... atau SB-Mid-server-..." autoComplete="off" />
        </Field>
        <Button loading={saving} onClick={simpan}>Simpan Server Key</Button>
      </Card>

      <Card style={{ padding: 24 }}>
        <SectionTitle icon={QrCode}>Webhook URL</SectionTitle>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16, marginTop: 6 }}>
          Paste URL ini ke dashboard Midtrans (Settings &gt; Configuration &gt; Payment Notification URL) supaya tagihan otomatis tercatat lunas begitu pelanggan bayar.
        </p>
        <div style={{ display: 'flex', gap: 8 }}>
          <Input value={webhookUrl} readOnly style={{ flex: 1 }} />
          <Button variant="soft" icon={copied ? Check : Copy} onClick={salinWebhook}>{copied ? 'Tersalin' : 'Salin'}</Button>
        </div>
      </Card>
    </div>
  )
}
